import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCrmConfig, DeleteCrmConfigProps } from '.';

export function useDeleteCrmConfig() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['crm_configs'],
        mutationFn: async (id: DeleteCrmConfigProps) => {
            const res = await deleteCrmConfig(id);
            if (res.error) throw new Error(res.error.message)
            return res.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['crm_configs']});
            queryClient.invalidateQueries({queryKey: ['project', 'list']});
        }
    })
}

